export default __webpack_public_path__ + "static/media/Mg.295fca81.svg";